import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from '../gsap-club/gsap-business-green/src/CustomEase';
gsap.registerPlugin( ScrollTrigger, CustomEase );

/* eslint-disable */
( function () {
	const ctaRelatedWork = document.querySelector( '.cta-related-work' );

	if ( ctaRelatedWork ) {
		const tl = gsap.timeline( { paused: true } );
		const wrap = ctaRelatedWork.querySelectorAll( '.cta-related-work__inner' );

		tl.from(wrap, {
			scaleX: 0.675,
			scaleY:0.675,
			duration: 0.3,
			ease: 'power3.out',
		}, 0);

		// create the ScrollTrigger instance
		const trigger = ScrollTrigger.create( {
			animation: tl,
			trigger: ctaRelatedWork,
			start: 'top bottom',
			end: "center center-=30%",
			scrub: 0.25
		} );
	}
} )();
/* eslint-enable */
